import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-grid p-m-1" }
const _hoisted_2 = { class: "p-col-6" }
const _hoisted_3 = { class: "p-col-6" }
const _hoisted_4 = { class: "p-col-6" }
const _hoisted_5 = { class: "p-col-6" }
const _hoisted_6 = { class: "p-field p-col-6" }
const _hoisted_7 = { class: "p-float-label p-m-2" }
const _hoisted_8 = { class: "kn-material-input-label" }
const _hoisted_9 = { class: "p-col-6 p-fluid" }
const _hoisted_10 = { class: "p-float-label p-m-2" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Card = _resolveComponent("Card")

  return (_ctx.options)
    ? (_openBlock(), _createBlock(_component_Card, {
        key: 0,
        class: "p-m-2"
      }, {
        header: _withCtx(() => [
          _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
            start: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.options')), 1)
            ]),
            _: 1
          })
        ]),
        content: _withCtx(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_Checkbox, {
                class: "p-mr-2",
                modelValue: _ctx.options.showvalue,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.options.showvalue = $event)),
                binary: true
              }, null, 8, ["modelValue"]),
              _createVNode("label", null, _toDisplayString(_ctx.$t('kpi.kpiDocumentDesigner.showValue')), 1)
            ]),
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_Checkbox, {
                class: "p-mr-2",
                modelValue: _ctx.options.showtarget,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.options.showtarget = $event)),
                binary: true
              }, null, 8, ["modelValue"]),
              _createVNode("label", null, _toDisplayString(_ctx.$t('kpi.kpiDocumentDesigner.showTarget')), 1)
            ]),
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_Checkbox, {
                class: "p-mr-2",
                modelValue: _ctx.options.showtargetpercentage,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.options.showtargetpercentage = $event)),
                binary: true
              }, null, 8, ["modelValue"]),
              _createVNode("label", null, _toDisplayString(_ctx.$t('kpi.kpiDocumentDesigner.showPercentage')), 1)
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_Checkbox, {
                class: "p-mr-2",
                modelValue: _ctx.options.showthreshold,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.options.showthreshold = $event)),
                binary: true
              }, null, 8, ["modelValue"]),
              _createVNode("label", null, _toDisplayString(_ctx.$t('kpi.kpiDocumentDesigner.showThreshold')), 1)
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("span", _hoisted_7, [
                _createVNode(_component_InputText, {
                  class: ["kn-material-input", {
                                'p-invalid': +_ctx.options.history.size < 0
                            }],
                  type: "number",
                  modelValue: _ctx.options.history.size,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.options.history.size = $event)),
                  min: "0"
                }, null, 8, ["modelValue", "class"]),
                _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('kpi.kpiDocumentDesigner.precision')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("span", _hoisted_10, [
                _createVNode(_component_Dropdown, {
                  class: "kn-material-input",
                  modelValue: _ctx.options.history.units,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.options.history.units = $event)),
                  options: _ctx.KpiDocumentDesignerOptionsCardDescriptor.unitsOptions,
                  optionValue: "value"
                }, {
                  value: _withCtx((slotProps) => [
                    (slotProps.value)
                      ? (_openBlock(), _createBlock("div", _hoisted_11, [
                          _createVNode("span", null, _toDisplayString(slotProps.value), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  option: _withCtx((slotProps) => [
                    _createVNode("span", null, _toDisplayString(_ctx.$t(slotProps.option.label)), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"]),
                _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('kpi.kpiDocumentDesigner.units')), 1)
              ])
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}